import request from './../plugins/axios'

// 项目列表表格 /business/project/list
function Projectlist (data) {
  return request({
    url: '/project/list',
    method: 'post',
    data
  })
}

// 所有项目列表 /business/project/list/all
function Projectalllist (data) {
  return request({
    url: '/project/list/all',
    method: 'post',
    data
  })
}
/**
 *
 * @param {撤点项目列表} data
 */
function selectRevertProjectList (data) {
  return request({
    url: '/staff/selectRevertProjectList',
    method: 'post',
    data
  })
}

/**
 *
 * @param {撤点} data
 */
function RevertProject (data) {
  return request({
    url: '/staff/revertProject',
    method: 'post',
    data
  })
}

/**
 * 选择人员
 * projectId
 *  */
function ProjectStfflist (data) {
  let url
  if (!data.projectId) {
    url = '/project/staff/list'
  } else {
    url = '/project/staff/list?projectId=' + data.projectId
  }
  return request({
    url,
    method: 'get'
  })
}
// 添加项目
function Projectadd (data) {
  return request({
    url: '/project/add',
    method: 'post',
    data
  })
}
// 工时查询
function projectTotalHours (data) {
  return request({
    url: '/project/totalHours',
    method: 'post',
    data
  })
}
// 项目编辑
function ProjectEdit (data) {
  return request({
    url: '/project/edit',
    method: 'post',
    data
  })
}
// 详情
function Projectdetail (data) {
  return request({
    url: '/project/detail?projectId=' + data.projectId,
    method: 'get'
  })
}
// 项目名称
function ProjectdName (data) {
  return request({
    url: '/project/name?projectId=' + data.projectId,
    method: 'get'
  })
}

// 判断项目名称
function Projectcheck (data) {
  return request({
    url: '/project/check?projectCode=' + data.projectCode,
    method: 'get'
  })
}

// 项目岗位列表 /business/project/post/list
function ProjectPostlist (data) {
  return request({
    url: '/project/post/list',
    method: 'post',
    data
  })
}

// 项目岗位列表 /business/project/post/list
function ProjectPostById (data) {
  return request({
    url: '/project/post/one',
    method: 'post',
    data
  })
}
// 项目位置
function projectPosition (data) {
  return request({
    url: '/project/position ',
    method: 'post',
    data
  })
}
// 校验范围
function StaffcheckAgeAndHeight (data) {
  return request({
    url: '/staff/checkAgeAndHeight',
    method: 'post',
    data
  })
}

// 队员列表 离职
// 参数{  staffId , reason leaveDate }
function projectStaffDimission (data) {
  return request({
    url: '/project/staff/dimission',
    method: 'post',
    data
  })
}

// 本周或者本月项目数
function ProjectTurnover (data) {
  return request({
    url: '/project/turnover',
    method: 'post',
    data
  })
}

// 装备列表
function ProjectConfigList (data) {
  return request({
    url: '/project/config/list',
    method: 'post',
    data
  })
}

// 变更记录 参数 projectId
function ProjectChangeList (data) {
  return request({
    url: '/change/list?projectId=' + data.projectId,
    method: 'get'
  })
}

// 提醒 参数 projectId
function ProjectRemindList (data) {
  return request({
    url: '/remind/list?projectId=' + data.projectId,
    method: 'get'
  })
}

// 续签合同
function ProjectRenewal (data) {
  return request({
    url: '/project/renewal',
    method: 'post',
    data
  })
}
//
function ProjectChangedesc (data) {
  return request({
    url: '/change/detail?id=' + data.id,
    method: 'get'
  })
}
// 新上项目通过参数
function ProjectModulePass (data) {
  return request({
    url: '/project/module/pass?id=' + data.id + '&modules=' + data.modules,
    method: 'get'
  })
}

/**
 * 2020-07-07
 * 岗位添加编辑删除接口
 */
function ProjectPostAdd (data) {
  return request({
    url: '/project/post/add',
    method: 'post',
    data
  })
}
function ProjectPostEdit (data) {
  return request({
    url: '/project/post/edit',
    method: 'post',
    data
  })
}
function ProjectPostDel (data) {
  return request({
    url: '/project/post/del',
    method: 'post',
    data
  })
}

export {
  Projectlist,
  Projectalllist,
  ProjectStfflist,
  Projectadd,
  Projectdetail,
  Projectcheck,
  ProjectPostlist,
  ProjectPostById,
  ProjectEdit,
  projectTotalHours,
  StaffcheckAgeAndHeight,
  ProjectdName,
  projectPosition,
  selectRevertProjectList,
  RevertProject,
  projectStaffDimission,
  ProjectTurnover,
  ProjectConfigList,
  ProjectRemindList,
  ProjectChangeList,
  ProjectRenewal,
  ProjectChangedesc,
  ProjectModulePass,
  ProjectPostAdd,
  ProjectPostEdit,
  ProjectPostDel
}
